/**
 * @generated SignedSource<<5b29a1fcb430bbbb0047eeedd8e0857d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type shareArticle20Content$data = {
  readonly " $fragmentSpreads": FragmentRefs<"popupArticle20ShareMenuContent">;
  readonly " $fragmentType": "shareArticle20Content";
};
export type shareArticle20Content$key = {
  readonly " $data"?: shareArticle20Content$data;
  readonly " $fragmentSpreads": FragmentRefs<"shareArticle20Content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "shareArticle20Content",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "popupArticle20ShareMenuContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "de5dfe911ddd66b059bedfc785545ceb";

export default node;
